import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ButtonsModule } from '@sml/buttons';
import { IconsComponent } from '@sml/icons';
import { PlatformService } from '@sml/utility';

@Component({
  selector: 'sml-sub-header',
  standalone: true,
  imports: [CommonModule, IconsComponent, ButtonsModule],
  templateUrl: './sub-header.component.html',
  styleUrls: ['./sub-header.component.scss'],
})
export class SubHeaderComponent implements OnInit {
  @Input() backText = 'Back';
  @Output() backClick = new EventEmitter<boolean>();
  public isIframe = false;
  onBackClick(): void {
    this.backClick.emit(true);
  }
  constructor(
    private readonly platformService: PlatformService,


  ) { }
  ngOnInit() {
    if (this.platformService.browser()) {
      this.isIframe = window.self !== window.top;
    }
  }
}
